import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=4bf28519&scoped=true"
import script from "./EditPassword.vue?vue&type=script&lang=js"
export * from "./EditPassword.vue?vue&type=script&lang=js"
import style0 from "./EditPassword.vue?vue&type=style&index=0&id=4bf28519&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf28519",
  null
  
)

export default component.exports